module.exports = __webpack_public_path__ + "img/espa_en.e0c0558a.jpg";